<template>
  <div class="logo-title">
    <div class="title fade-up">
      {{title}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoTitle',
  props: {
    title: {
      type: String
    }
  },
  data: () => {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style>
</style>

<style scoped>
.title.fade-up {
  font-family: 'Caveat';
  font-size: 6.5rem;
  animation-duration: 2s;
}
@media screen and (max-width: 600px) {
  .title.fade-up {
    font-size: 4.2rem;
    margin-bottom: 6px;
  }
}
@media screen and (max-width: 500px) {
  .title.fade-up {
    font-size: 3.6rem;
  }
}
@media screen and (max-width: 350px) {
  .title.fade-up {
    font-size: 2.6rem;
  }
}
</style>
